import script from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./ModalTemplate.vue?vue&type=style&index=0&id=6f76c1ea&lang=less"

const __exports__ = script;

export default __exports__